module.exports = __webpack_public_path__ + "static/img/fontello.7199cf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/fontello/font/fontello.svg?32974303
// module id = kg7+
// module chunks = 25